import { render } from "./SuccessModal.vue?vue&type=template&id=1f22128b&scoped=true"
import script from "./SuccessModal.vue?vue&type=script&lang=js"
export * from "./SuccessModal.vue?vue&type=script&lang=js"

import "./SuccessModal.vue?vue&type=style&index=0&id=1f22128b&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f22128b"]])

export default __exports__